import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  InputBase,
  Tooltip,
  IconButton,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseReminder } from "./UseReminder";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import ViewListIcon from "@mui/icons-material/ViewList";
import { toMoney } from "../../util/Utils";
import CustomersList from "./CustomersList";

export default function Reminder(props) {
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("MobileCount", "Desc");
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { AvailableProducts, UnavailableProducts } = UseReminder();
  const [stockState, setStockState] = useState("available");
  const [openCustomers, setOpenCustomers] = useState({
    show: false,
    productID: undefined,
  });
  const [productRes, setProductRes] = useState();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    if (stockState == "available") {
      setProgress(true);
      AvailableProducts(myPc, search, true, (products) => {
        setProgress(false);
        setProductRes(products);
      });
    } else if (stockState == "unAvailable") {
      setProgress(true);
      UnavailableProducts(myPc, search, true, (products) => {
        setProgress(false);
        setProductRes(products);
      });
    }
  }, [myPc, stockState]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "productID",
      width: 110,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              if (cellValues.row.productURL) {
                window.open(cellValues.row.productURL, "_blank");
              }
            }}
          >
            {cellValues.row.productID}
          </Typography>
        );
      },
    },
    {
      field: "productName",
      headerName: "نام محصول",
      width: 260,
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "mobileCount",
      headerName: "درخواستی",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl" }}
          >
            {cellValues.row.mobileCount
              ? toMoney(cellValues.row.mobileCount)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "stoke",
      headerName: "موجودی",
      width: 110,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.stoke ? toMoney(cellValues.row.stoke) : 0}
          </Typography>
        );
      },
    },
    {
      field: "مشتریان",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "مشتریان",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="لیست مشتریان">
            <IconButton
              onClick={() =>
                setOpenCustomers({
                  stockState: stockState,
                  show: true,
                  productID: cellValues.row.productID,
                })
              }
            >
              <ViewListIcon color="secondary" />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/reminder" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Button
            sx={{ width: "100px", mr: 2 }}
            startIcon={stockState == "available" && <CheckIcon />}
            variant={stockState == "available" ? "contained" : "outlined"}
            onClick={() => {
              updatePage(1);
              setScrollTo(undefined);
              setStockState("available");
            }}
          >
            موجود
          </Button>
          <Button
            sx={{
              width: "100px",
            }}
            startIcon={stockState == "unAvailable" && <CheckIcon />}
            variant={stockState == "unAvailable" ? "contained" : "outlined"}
            onClick={() => {
              updatePage(1);
              setScrollTo(undefined);
              setStockState("unAvailable");
            }}
          >
            نا موجود
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {productRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={productRes.pageCondition.pageCount}
              rows={productRes.products}
              paginationMode="server"
              page={productRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={productRes.pageCondition.totalItemCount}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount: productRes.pageCondition.totalItemCount,
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
      {openCustomers.show && (
        <CustomersList
          openCustomers={openCustomers}
          setOpenCustomers={setOpenCustomers}
          callBack={() => {
            setOpenCustomers({ ...openCustomers, show: false });
            setSearchState("");
            setSearch("");
            if (stockState == "available") {
              setProgress(true);
              AvailableProducts(myPc, "", true, (products) => {
                setProgress(false);
                setProductRes(products);
              });
            } else if (stockState == "unAvailable") {
              setProgress(true);
              UnavailableProducts(myPc, "", true, (products) => {
                setProgress(false);
                setProductRes(products);
              });
            }
          }}
        ></CustomersList>
      )}
    </Detail>
  );
}
